import { Dayjs } from 'dayjs'

import { getNow, getNowConfig } from './getNow'

let _today = getNow().startOf('day')

// You can test this by changing this to 1000,
// which will cause it to update every second.
const hourMs = 60 * 60 * 1000

/**
 * This function updates the `_today` variable every hour.
 */
function update() {
    _today = getNow().startOf('day')
    const timeToNextHour = hourMs - (Date.now() % hourMs)
    setTimeout(update, timeToNextHour)
}

update()

// Cache for the mocked path that lives for a single synchronous computation
// cycle: the first call computes `startOf('day')`, subsequent calls within the
// same microtask reuse it, and a queued microtask clears it before the next
// task runs so changes to `getNowConfig.mockedNow` still take effect promptly.
let _mockedToday: Dayjs | undefined
let _mockedTodayScheduled = false

const getMockedToday = (): Dayjs => {
    if (_mockedToday === undefined) {
        _mockedToday = getNow().startOf('day')
        if (!_mockedTodayScheduled) {
            _mockedTodayScheduled = true
            queueMicrotask(() => {
                _mockedToday = undefined
                _mockedTodayScheduled = false
            })
        }
    }
    return _mockedToday
}

// When a mock date is configured, always read from getNow() at call time
// so the correct date is returned regardless of when the mock was set up.
export const getToday = () => (getNowConfig.mockedNow ? getMockedToday() : _today)
